import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Image } from 'semantic-ui-react';
import { APP_HEADER_TEXT } from '../../constants/views';
import ObjectITButton from './developed_by_objectit/objectit_button';

class AppHeader extends Component {
  render() {
    const {
      showMenu,
      showLoading,
      tagName,
      onMenuClick,
      onTitleFocus,
      onTitleBlur,
      isLoggedIn,
    } = this.props;

    return (
      <header className="App-header">
        <div className="header-logo">
          {showMenu && (
            <i className="bars icon" onClick={(evt) => onMenuClick(evt)} />
          )}
          <Image src="/aa_logo_09302024.png" className={showMenu.toString()} />
        </div>
        <div className={"App-title " + showMenu.toString()}>
          <span>
            <b>{APP_HEADER_TEXT}</b>
          </span>
          {tagName && tagName.length > 0 && (
            <span id="title_dash">{" - "}</span>
          )}
          {tagName && tagName.length > 0 && (
            <span
              id="title_matrix_name"
              onFocus={(evt) => onTitleFocus(evt)}
              onBlur={(evt) => onTitleBlur(evt)}
              tabIndex="-1"
            >
              {tagName}
            </span>
          )}
          {showLoading && (
            <div id="loading-message">
              <i className="loading circle notched icon"></i>
              <span>Loading...</span>
            </div>
          )}
        </div>
        {!isLoggedIn && (
          <ObjectITButton />
        )}
      </header>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoggedIn: state.token.loginSuccess
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

let SystemHeader = connect(mapStateToProps, mapDispatchToProps)(AppHeader);
export default SystemHeader;



// WEBPACK FOOTER //
// ./src/views/components/system_header.js